export enum AutomationFormErrorType {
  DupContent = 'duplicated content',
  /* TODO: change this back to 'duplicated sample name' once finished backend renaming */
  DupSampleName = 'duplicated highlight name',
}
